import { ActionButton, DocumentCard, DocumentCardImage, Icon, ImageFit } from '@fluentui/react';
import { baseUrlAdmin } from '../../../../../constants/url.constant';
import ChatButton from '../../../../common/views/ChatButton';
import { Utils } from '../../../../common/views/Utils';
import { emptyFunc } from '../../../../home/models/OtherTypes';
import { ProductUtils } from '../../../../products/views/ProductUtils';
import { OrderModel, OrderStatus } from '../../../models/OrderModel';
import OrderTrackingView from '../../shared/OrderTrackingView';
import { OrderUtils } from '../../shared/OrderUtils';

export type OrderItemProps = {
    order: OrderModel;
    onDetail: (id: number) => void;
    onPlaceOrder: (id: number, onCompleted: emptyFunc) => void;
    onCompleted: () => void;
}

export default function OrderItemView({
    order, onDetail, onPlaceOrder, onCompleted
}: OrderItemProps) {
    const now = new Date();
    const width3 = Utils.getColumnWidth(3);
    const width4 = Utils.getColumnWidth(4);
    const width6 = Utils.getColumnWidth(6);
    const width8 = Utils.getColumnWidth(8);

    const product = order.product;
    let url = product ? ProductUtils.getImageUrl(baseUrlAdmin, product.picture) : "";
    const amount = order.price * order.qty * (100 + order.rate) / 100;
    const total = amount + order.domesticShipping + order.chargeWeight * order.shippingRate;

    let shippingText = "Shipping ($" + Utils.formatNumber(order.shippingRate);
    shippingText += " x " + Utils.formatNumber(order.chargeWeight) + "lbs)";

    const productInfo = () => {
        return <div className="pb-10 ph-5 left">
            <div className="ms-Grid-row">
                <div className={width6 + " font-bold"}>{order.customer}</div>
                <div className={width6 + " right"}>
                    {order.warehouse.name}
                </div>
            </div>

            <div className="ms-Grid-row pt-5">
                <div className={width6 + " left gray font-smaller"}>
                    {Utils.getDaysAndHoursDiffText(now, order.orderDate)}
                </div>
                <div className={width6 + " right"}>
                    {Utils.splitCapitalText(OrderStatus[order.status])}
                </div>
            </div>

            {product && <div>
                {!Utils.isNullOrEmpty(product.name) && <div>
                    {product.name}
                </div>}

                <div className="gray font-smaller">
                    {!Utils.isNullOrEmpty(product.description) && <div className="pt-5 limit-lines two-lines">
                        {product.description}
                    </div>}

                    {product.weight > 0 && <div className="pt-5">
                        Weight: {Utils.formatNumber(product.weight)} lbs
                    </div>}

                    {!Utils.isNullOrEmpty(product.dimension) && <div className="pt-5">
                        {product.dimension}
                    </div>}
                </div>
            </div>}
        </div>
    }

    const headerRow = () => {
        return <div
            className="ms-Grid-row gray p-5"
            style={{ backgroundColor: Utils.altRowColor }}>
            <div className={width3 + " left"}>Price</div>
            <div className={width3 + " right"}>Qty</div>
            <div className={width3 + " right"}>Rate</div>
            <div className={width3 + " right"}>Amount</div>
        </div>;
    }

    const priceRow = (amount: number) => {
        return <div className="ms-Grid-row p-5">
            <div className={width3 + " left"}>$ {Utils.formatNumber(order.price)}</div>
            <div className={width3 + " right"}>{order.qty}</div>
            <div className={width3 + " right"}>{order.rate} %</div>
            <div className={width3 + " right"}>$ {Utils.formatNumber(amount)}</div>
        </div>;
    }

    const actionRow = () => {
        return <div className="ms-Grid-row default-toolbar">
            <div className={width4 + " left"}>
                <ChatButton />
            </div>

            <div className={width4 + " center"}>
                {order.status === OrderStatus.quote && <>
                    <ActionButton
                        iconProps={{ iconName: "ShoppingCart" }}
                        onClick={() => onPlaceOrder(order.id, onCompleted)}
                    >Place Order</ActionButton>
                </>}
            </div>

            <div className={width4 + " right"}>
                <ActionButton
                    iconProps={{ iconName: "NumberedListTextMirrored" }}
                    onClick={() => onDetail(order.id)}
                >Detail</ActionButton>
            </div>
        </div>;
    }

    const onProductDetail = () => {
        if (order.product && order.product.link) {
            window.open(order.product.link, "_blank");
        } else {
            alert("Product link not available.");
        }
    }

    return <DocumentCard className="picture-wrapper order-product-picture-card ph-15"
        styles={{ root: { maxWidth: "100%" } }}>
        <div className="ms-Grid default-border">
            <div className="ms-Grid-row pv-20 cursor" onClick={onProductDetail}>
                <DocumentCardImage
                    height={160}
                    imageFit={ImageFit.centerCover}
                    className="product-picture image-radius"
                    imageSrc={url} />
            </div>

            {productInfo()}
            {headerRow()}
            {priceRow(amount)}

            <div className="ms-Grid-row pt-10 ph-5 blue-background">
                <div className={width8 + " gray right"}>Shipping in US</div>
                <div className={width4 + " right"}>
                    $ {Utils.formatNumber(order.domesticShipping)}
                </div>
            </div>

            <div className="ms-Grid-row pt-5 ph-5 blue-background">
                <div className={width8 + " gray right"}>{shippingText}</div>
                <div className={width4 + " right"}>
                    $ {Utils.formatNumber(order.chargeWeight * order.shippingRate)}
                </div>
            </div>

            <div className="ms-Grid-row pt-5 pb-10 ph-5 blue-background">
                <div className={width8 + " gray right"}>Total</div>
                <div className={width4 + " right"}>$ {Utils.formatNumber(total)}</div>
            </div>

            {OrderUtils.isOrderStatus(order.status) && <div className="ph-5 pt-15 pb-5">
                <OrderTrackingView trackings={order.trackings} />
            </div>}

            {actionRow()}
        </div>
    </DocumentCard>;
}